import { AbstractControl, MaxLengthValidator } from '@angular/forms';

export function ValidateStreet(control: AbstractControl) {

    let format = /[!@~$%^&*()_+\=\[\]{};:`"\\|,<>\?]+/
    if (format.test(control.value)) {
        return { invalidStreet: true }
    }

    if (control.value.length > 35) {
        return { invalidStreet: true }
    }
    return null;
}

export function ValidateApartment(control: AbstractControl) {

    let format = /[!@#~$%^&*()_+\=\[\]{};`':"\\|,.<>\/?-\s]+/
    if (format.test(control.value)) {
        return { invalidApartment: true }
    }

    if (control.value.length > 4) {
        return { invalidApartment: true }
    }
    return null;
}


export function ValidateCity(control: AbstractControl) {
    let format = /['!@#~$%^&*()_+\=\[\]{};`:"\\|,<>\/?]+/;
    if (format.test(control.value)) {
        return { invalidCity: true }
    }
    if (control.value.length > 24) {
        return { invalidCity: true }
    }
    return null;
}

export function ValidatePostal(control: AbstractControl) {
    let pattern = /[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]/
    if (pattern.test(control.value)) {
        return { invalidPostal: true }
    }

    return null;

}



